import React from "react";
import { useParams } from "react-router";
import { CreateAndEditAccount } from "./components/CreateAndEditAccount";

export const AccountEditPage = () => {
  const { accountId } = useParams<"accountId">();

  return <CreateAndEditAccount type="account" accountId={accountId!} />;
};
